export const apiEndpoint = ['localhost', 'localho.st'].includes(window.location.hostname)?
    'https://api.localho.st:8080' :
    `${window.location.protocol}//${window.location.host.replace('teachers', 'api')}`;

export const COPYRIGHT_EMAIL_US             = "Any questions? Just email us at ";
export const COPYRIGHT_EMAIL_TO             = "support@funexpected.org";
export const COPYRIGHT_LANDING_LINK         = "https://funexpectedapps.com";
export const PROFILE_NAME                   = "Name";
export const PROFILE_EMAIL                  = "Email";
export const PROFILE_POSITION               = "Role";
export const PROFILE_SCHOOL                 = "School name";
export const PROFILE_ADDRESS                = "School address";
export const PROFILE_SITE                   = "School website";
export const MENU_PROFILE                   = "Profile";
export const MENU_HOME                      = "Home";
export const MENU_LOGOUT                    = "Logout";
export const MENU_DARK_MODE                 = "Dark mode";
export const MENU_LIGHT_MODE                = "Light mode";
export const ADD_FORM_HEADER                = "Add student";
export const ADD_FORM_INVALID_DATE_FORMAT   = 'Please use “Month Year” format (e.g. "May 2017").';
export const ADD_FORM_INVALID_DATE_RANGE    = "Date must not be earlier than January 2011.";
export const ADD_FORM_INVALID_EMAIL         = "Please enter a valid email address.";
export const ADD_FORM_EMAIL_TOOLTIP_HEADER  = "Why add a parent email?";
export const ADD_FORM_EMAIL_TOOLTIP_TEXT    = "Parents can then provide continued education at home with an extended free trial period - an essential element in keeping our Teacher's Edition free!";
export const ADD_FORM_DATE_TOOLTIP_HEADER   = "Why do we ask for this info?";
export const ADD_FORM_DATE_TOOLTIP_TEXT     = "We use students' month and year of birth to automatically adjust the difficulty level of app questions.";
export const ADD_FORM_NAME                  = "Student Name";
export const ADD_FORM_DATE                  = "Month and Year of Birth";
export const ADD_FORM_DATE_PLACEHOLDER      = "";
export const ADD_FORM_EMAIL                 = "Parent's Email";
export const ADD_FORM_BUTTON                = "Add student";
// "Add students" frame — names one-per-line + CSV upload
export const ADD_STUDENTS_HEADER            = "Add students";
export const ADD_STUDENTS_SUBHEADER         = "Enter student names, one name per line.";
export const ADD_STUDENTS_PLACEHOLDER       = "Example:\nLiam J\nNoah M\nOlivia S";
export const ADD_STUDENTS_BUTTON            = "Submit";
export const ADD_STUDENTS_EMPTY_ERROR       = "Enter student names";
export const ADD_STUDENTS_INVALID_FILE      = "Invalid file format.";
// Per-row problems surfaced by the client-side CSV parse (AddStudentsFields), prefixed
// with "Row N: ".
export const ADD_STUDENTS_CSV_ROW_MISSING_NAME  = "missing name — row skipped.";
export const ADD_STUDENTS_CSV_ROW_EXTRA_COLUMNS = "extra columns ignored (only name columns are imported).";
export const ADD_STUDENTS_UPLOAD            = "Upload students (CSV)";
export const ADD_STUDENTS_DOWNLOAD          = "Download template";
export const STUDENTS_TABLE_NAME            = "Student Name";
export const STUDENTS_TABLE_NUM             = "#";
export const STUDENTS_TABLE_DATE            = "Birth Month/Year";
export const STUDENTS_TABLE_PROGRAM         = "Program";
export const STUDENTS_TABLE_EMAIL           = "Parent's Email";
export const STUDENTS_TABLE_EMAIL_ERROR     = "Please enter a valid email address.";
export const STUDENTS_TABLE_EMPTY           = "No students added yet";
export const STUDENTS_TABLE_DATA_ERROR      = "Error retrieving data, please try again.";
export const STUDENTS_TABLE_HEADER          = "Your class";
export const STUDENTS_TABLE_DELETE          = "Delete";
export const STUDENTS_TABLE_EDIT            = "Edit";
export const STUDENTS_TABLE_SAVE            = "Save";
export const STUDENTS_TABLE_CANCEL          = "Cancel";
export const STUDENTS_TABLE_DONE_BUTTON     = "Done";
export const TEACHERS_GUIDE_LINK            = "https://welcome.funexpectedapps.com/resources";
export const TEACHERS_LANDING_LINK          = "https://funexpectedapps.com/teachers";
export const DIALOG_DELETE_TITLE            = "Remove student?";
export const DIALOG_DELETE_CONTENT_1        = "Sure you want to remove";
export const DIALOG_DELETE_CONTENT_2        = "from your class?";
export const DIALOG_DELETE_CONTENT_3        = "This action cannot be undone.";
export const DIALOG_DELETE_CONFIRM          = "Remove";
export const DIALOG_DELETE_DISCARD          = "Cancel";
export const CONNECT_APPLE_HEADER           = "Connect to Apple School Manager";
export const CONNECT_APPLE_SUBHEADER        = "Set up your class on Apple School Manager and install the app on school devices";
export const CONNECT_APPLE_BUTTON           = "Connect";
export const CONNECT_APPLE_LINK             = "Learn more with our educator resources";
export const CREATE_CLASS_BUTTON            = "Create class";
export const CREATE_CLASS_TITLE             = "Create class";
export const CREATE_CLASS_FORM_NAME         = "Class name";
export const CREATE_CLASS_FORM_GRADE        = "Select grade";
// Grade ids/labels and program labels are NOT defined client-side — they come from
// GET /programs (hooks/useProgramCatalog.ts); fcs/programs.py is the single source
// of truth.
// "Review students" frame
export const REVIEW_STUDENTS_HEADER         = "Review students";
export const REVIEW_STUDENTS_SUBHEADER      = "Set an individual starting level for each student.";
export const REVIEW_STUDENTS_CONFIRM        = "Confirm";
export const CREATE_CLASS_FORM_SUBMIT       = "Create";
export const EMAIL_SENT_HEADER              = "Check your email";
export const EMAIL_SENT_TEXT_1              = "We've sent a login link to ";
export const EMAIL_SENT_TEXT_2              = ".";
export const EMAIL_SENT_TEXT_3              = "The link will remain active for 7 days.";
export const CLASSES_TABLE_HEADER           = "All classes";
export const CLASSES_TABLE_NUM              = "#";
export const CLASSES_TABLE_CLASS_NAME       = "Name";
export const CLASSES_TABLE_TEACHER          = "Teacher";
export const CLASSES_TABLE_MODE             = "Mode";
export const CLASSES_TABLE_GRADE            = "Grade";
export const CLASSES_TABLE_STUDENT_NUM      = "Students";
export const CLASSES_TABLE_NO_CLASSES       = "No classes";
export const CLASSES_TABLE_DELETE_CLASS     = "Delete class";
export const CLASSES_TABLE_EDIT_CLASS       = "Edit class";
export const CLASSES_TABLE_ADD_STUDENTS     = "Add students";
export const CLASSES_TABLE_SHOW_QR_CODES    = "Show login QR codes";
export const CLASS_VIEW_TEACHER             = "Educators";
export const CLASS_VIEW_STUDENTS            = "Students";
export const CLASS_VIEW_TEACHER_GUIDE       = "Educator Login Instructions";
export const CLASS_VIEW_STUDENT_GUIDE       = "Student Login Instructions";
export const CLASS_VIEW_DOWNLOAD_PDF_QR     = "Download login QR codes";
// Rendered as <ol> items (TeacherGuide/StudentGuide) — no hand-numbering here.
export const TEACHER_GUIDE_1                = "Download the Funexpected Math app on your device";
export const TEACHER_GUIDE_2                = "Find your QR code next to your name here, on the Classes page";
export const TEACHER_GUIDE_3                = "Scan it with your device to log in";
export const STUDENT_GUIDE_1                = "Download the Funexpected Math app on the student's device";
export const STUDENT_GUIDE_2                = "Find the student’s QR code next to their name here, on the Classes page";
export const STUDENT_GUIDE_3                = "Scan it with their device to log in";
export const FUNEXPECTED_APPSTORE           = "https://apps.apple.com/app/id1473965253";
export const FUNEXPECTED_GOOGLE_PLAY        = "https://play.google.com/store/apps/details?id=ltd.funexpected.math";
export const QR_CODES_POPUP_HEADER          = "Login QR codes";
export const QR_CODE_POPUP_HEADER           = "Login QR code";
export const DELETE_CLASS_POPUP_HEADER      = "Delete class";
export const DELETE_CLASS_POPUP_TEXT_1      = "Sure you want to delete ";
export const DELETE_CLASS_POPUP_TEXT_2      = "? This action cannot be undone.";
export const DELETE_CLASS_POPUP_CANCEL      = "Cancel";
export const DELETE_CLASS_POPUP_DELETE      = "Delete";
export const EDIT_CLASS_POPUP_HEADER        = "Edit class";
export const EDIT_CLASS_POPUP_CANCEL        = "Cancel";
export const EDIT_CLASS_POPUP_SAVE          = "Save changes";
export const FORM_NEW_TEACHER_ERROR         = "An error has occurred.";
export const FORM_NEW_TEACHER_HEADER        = "Let's get started";
export const FORM_NEW_TEACHER_SUBHEADER     = "To continue, we need to verify your educator status and set up your account.";
export const FORM_NEW_TEACHER_FIRST_NAME    = "First name";
export const FORM_NEW_TEACHER_LAST_NAME     = "Last name";
export const FORM_NEW_TEACHER_ROLE          = "Role";
export const FORM_NEW_TEACHER_SHOOL         = "School or organization name";
export const FORM_NEW_TEACHER_SHOOL_ADDRESS = "School address";
export const FORM_NEW_TEACHER_SHOOL_WEBSITE = "School website";
export const FORM_NEW_TEACHER_HELPER        = "A valid school website will help us verify your profile.";
export const FORM_NEW_TEACHER_SUBMIT        = "Continue";
export const CLASS_TABLE_QR_CODE_TITLE      = "Show student's login QR code";
export const CLASS_TABLE_MORE_ACTIONS       = "More actions";
export const CLASS_TABLE_REMOVE             = "Remove";
export const CLASS_TABLE_EDIT               = "Edit";
export const CLASS_TABLE_MOVE               = "Move to another class";
export const TEACHERS_TABLE_NAME            = "Name";
export const TEACHERS_TABLE_EMAIL           = "Email";
export const TEACHER_TABLE_QR_CODE_TITLE    = "Show login QR code";
export const CLASS_MENU_EDIT                = "Edit class";
export const CLASS_MENU_DELETE              = "Delete class";
export const CLASS_MENU_SHOW_QR_CODES       = "Show login QR codes";
export const CLASS_ADD_STUDENTS_BUTTON      = "Add students";
export const THANK_YOU_HEADER               = "Congratulations!";
export const THANK_YOU_TEXT                 = "You're now connected to Apple School Manager! Why not check out our 'Starting your class' PDF?";
export const THANK_YOU_BUTTON               = "Download";
export const STORE_LINK                     = "https://click.funexpected.org/47aD/store";
export const STARTING_CLASS_LINK            = "https://dl.dropboxusercontent.com/s/2g1gm09ilqogezc/Funexpected%20starting%20your%20class.pdf";
export const SIGNIN_HEADER                  = "Log in as educator";
export const SIGNUP_HEADER                  = "Create educator account";
export const SIGNIN_BUTTON_APPLE            = "Apple School Manager";
export const SIGNIN_BUTTON_EMAIL            = "Continue with email";
export const SIGNIN_WITH_EMAIL_HEADER       = "Enter your work email to receive your login link";
export const SIGNIN_WITH_EMAIL_EMAIL        = "Work email";
export const SIGNIN_WITH_EMAIL_SUBMIT       = "Continue with email";
export const SIGNIN_WITH_EMAIL_EMPTY_EMAIL  = "Please, enter email";
export const SIGNIN_WITH_EMAIL_WRONG_EMAIL  = "Please enter a valid email address";
export const SIGNIN_WITH_EMAIL_PUBLIC_EMAIL  = "Please enter a work email address";
export const EDIT_STUDENT_TITLE             = "Edit student details";
export const DELETE_STUDENT_TITLE           = "Remove student";
export const DELETE_STUDENT_POPUP_DELETE    = "Remove";
export const DELETE_STUDENT_POPUP_TEXT_1    = "Sure you want to remove ";
export const DELETE_STUDENT_POPUP_TEXT_2    = " from your class? This action cannot be undone.";
export const WRONG_URI_ERROR                = "Wrong URI!";
export const LOGIN_ERROR_DICT = {
    "INVALID_PASSWORD":             "Incorrect password.",
    "INVALID_EMAIL":                "Please enter a valid email.",
    "EMAIL_NOT_FOUND":              "We couldn't find an account for that email address.",
    "ALREADY_EXISTS":               "Account already exists.",
    "TOO_MANY_ATTEMPTS_TRY_LATER":  "Too many attempts. Please try again later.",
    "NON_MANAGED_ACCOUNT":          "Only Apple Managed Accounts supported.",
    "WRONG_DATA":                   "WRONG DATA",
};
export const IMPORT_STUDENTS_TEMPLATE       = "Download CSV template";
export const IMPORT_STUDENTS_BUTTON         = "Upload CSV";
export const IMPORT_STUDENTS_ERROR_HEADER   = "Error uploading file: ";
export const IMPORT_STUDENTS_ERROR_MESSAGES: Record<string, string> = {
    "BROKEN_FILE": "Invalid file format."
};